import styled, { css } from 'styled-components';
import { Container, Row } from 'react-bootstrap';

const RobotBox = styled(Row)`${
  (props) => css`
    background: 
        transparent linear-gradient(180deg, ${props.background.colorA} 0%, ${props.background.colorB} 100%) 0% 0% no-repeat padding-box;
    border-radius: 22px;
    @media (max-width: 568px) {
      border-radius: 0px;
    }
    color: #ff0000;
`}`;

export default RobotBox;
